import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import Select, { components } from "react-select";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import { IOSSwitch } from "./IOSSwitch";
import "./myschedule.css";
import { PROCEDURE_SLOTS } from "../Constants";
import deleteIcon from "../../../../assets/deleteIcon.png";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MyScheduleModal from "../Modals/MyScheduleModal";
import MyScheduleFeesContext from "../MyScheduleFeesContext";
import TimePickerModal from "../Modals/TimePickerModal";
import Loader from "../../../UI Component/Loader/Loader";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { GET_RESOURCE_PROCEDURE_LIST } from "../MyScheduleFeesApiHandler/apiConstants";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import { roundToTwoDecimalPlaces } from "../ViewLogs/helper";
import { c2cGetApiHandler } from "../../../../Util/c2cApiHandler";
import GSTDropdown from "./Common/GSTDropdown";
import { calculateDiscountedAmount, callGetDoctorResourceAPI } from "../helper";

export default function ProcedureForm(props) {
  const {
    consultationType,
    getProcedure,
    handleSlotType,
    handleEnableAllSLotButton,
    handleProcedureCounter,
    staffDoctor,
    setCommonProcedure,
  } = props;

  const { setSelectedConsultationType, selectedConsultationType } = useContext(
    MyScheduleFeesContext
  );
  const { register, handleSubmit, errors, control, setValue, reset } = useForm(
    {}
  );
  const [fees, setFees] = useState(0);
  const [instruction, setInstruction] = useState("");
  const [discount, setDiscount] = useState("");
  const [commission, setCommission] = useState("");
  const [totalCommission, setTotalCommission] = useState(0);

  const hasAppliedDiscount = false;
  const [procedure_name, setProcedureName] = useState("");
  const [consultation_method, setConsultationMethod] = useState("offline");
  const [allowOnlinePayment, setAllowOnlinePayment] = useState(false);
  const [procedure_id, setProcedureId] = useState();
  const [isDeleted, setIsDeleted] = useState(false);
  const [toggleButton, settoggleButton] = useState(true);
  const [ErrorModal, setErrorModal] = useState(false);
  const [offlineCheck, setofflineCheck] = useState(false);
  const [pendingappointments, setpendingappointments] = useState("");
  const [deletemodal, setdeletemodal] = useState(false);
  const [createModal, setcreateModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [discount_fees, setdiscountedFees] = useState(0);
  const [payableFee, setpayableFee] = useState();
  const [showtimepicker, setTimePicker] = useState(false);
  const [procedure_slotValue, setProcedureSlotValue] = useState({});
  const [procedureConsultationType, setProcedureConsultationType] = useState(
    {}
  );
  const [slotSuccessModal, setSlotSuccessModal] = useState(false);
  const [title, setTitle] = useState("");
  const [loading, setLoader] = useState(false);
  const [peviousSlotValue, setPreviousSlotsVal] = useState({});
  const [editerror_message, setEditErrorMessage] = useState("");
  const [editerror, setEditError] = useState(false);
  const [resourceData, setResourceData] = useState([]);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [gstPercentage, setGstPercentage] = useState(0);
  const [resourceId, setResourceId] = useState("");
  const [checkboxValue, setCheckboxValue] = useState([
    {
      id: "1",
      name: "+5%",
      value: 5,
      checked: false,
    },
    {
      id: "2",
      name: "+10%",
      value: 10,
      checked: false,
    },
    {
      id: "3",
      name: "+15%",
      value: 15,
      checked: false,
    },
  ]);

  const [hsnValue, setHsnValue] = useState("");
  const [hsnMandatory, setHsnMandatory] = useState(false);
  const [CTAEnable, setCTAEnable] = useState(false);
  const [hsnError, setHsnError] = useState(false);

  const doctor_context = useContext(DoctorContext);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const details =
    doctorRole === USER_ROLE.DOCTOR_ADMIN ||
    doctorRole === USER_ROLE.RESOURCE_ADMIN ||
    userType === APPLICABLE_ROLE.STAFF
      ? staffDoctor.id
      : userId;

  useEffect(() => {
    const isGstSet = gstPercentage !== 0;
    setHsnMandatory(isGstSet);
    setCTAEnable(isGstSet);
  }, [gstPercentage]);

  useEffect(() => {
    const isInvalidHSN = hsnValue?.length < 6;
    setCTAEnable(gstPercentage !== 0 ? isInvalidHSN : false);
    setHsnError(!!hsnValue && isInvalidHSN);
  }, [gstPercentage, hsnValue]);

  useEffect(() => {
    if (
      localStorage.getItem("isResourceArray") === "True" ||
      doctorRole === USER_ROLE.RESOURCE_CONSULTANT
    ) {
      getResourceProcedureList(details);
    }
    if (consultationType.value != "4") {
      getParticularProcedure();
    } else {
      let consultation_duration = PROCEDURE_SLOTS.find(
        (data) => data.value == selectedConsultationType.consultation_duration
      );
      setpayableFee();
      setDiscount("");
      setProcedureName("");
      setInstruction("");
      setdiscountedFees(0);
      setFees(0);
      if (selectedConsultationType.common_procedure) {
        setValue("slots", consultation_duration);
      } else {
        reset();
      }
    }
  }, [consultationType]);

  useEffect(() => {
    calculateTotalAmount();
  }, [commission, fees, discount]);

  const getResourceProcedureList = (detail) => {
    c2cGetApiHandler(GET_RESOURCE_PROCEDURE_LIST(detail))
      .then((res) => {
        const extractedData = res[0]?.data?.data?.map((item) => ({
          value: item.id,
          label: item.name,
          resourceIds: item.resource_mapping_id,
        }));
        setResourceData(extractedData);
      })
      .catch((err) => {
        C2CConsole.error("Error fetching resources", err);
      });
  };

  function getParticularProcedure() {
    let api_url = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      api_url = "/clinic/get-procedure";
      payload = {
        doctor_id:
          doctorRole === USER_ROLE.DOCTOR_ADMIN ||
          doctorRole === USER_ROLE.RESOURCE_ADMIN ||
          userType === APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
        procedure_id: consultationType.value,
      };
    } else {
      api_url = "/doctor/get-procedure";
      payload = {
        doctor_id:
          userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
        procedure_id: consultationType.value,
      };
    }
    afterLoginApiAxios({
      method: "post",
      url: api_url,
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: payload,
    })
      .then((response) => {
        if (response.data.statusCode == 200) {
          if (response.data.procedure_details.length > 0) {
            let resData = response.data.procedure_details[0];
            setProcedureId(resData.id);
            setValue("procedure_name", resData.procedure_name);
            setResourceId(resData.resources_tests_mapping_id);
            setProcedureName(resData.procedure_name);
            let consultation_duration = PROCEDURE_SLOTS.find(
              (data) => data.value == resData.consultation_duration
            );
            setValue("slots", consultation_duration);
            setValue("fees", resData.fees);
            setFees(Number(resData.fees));
            setValue("discount_percentage", resData.discount_percentage);
            setDiscount(resData.discount_percentage);
            setCommission(
              resData.doctor_commission_percentage
                ? resData.doctor_commission_percentage
                : ""
            );
            setValue("instruction", resData.instruction);
            setInstruction(resData.instruction);
            settoggleButton(resData.is_active == "True" ? true : false);
            setIsDeleted(resData.is_deleted.toLowerCase());
            setAllowOnlinePayment(
              resData.online_payment_enabled === "True" ? true : false
            );
            setValue("consultation_method", "offline"); //added newly only offline
            setdiscountedFees(
              resData.discounted_amount ? resData.discounted_amount : 0
            );

            const finalCost = getFinalCost(resData.fees);
            setpayableFee(finalCost);

            handleSlotType(consultation_duration);
            handleEnableAllSLotButton(false);
            setPreviousSlotsVal(consultation_duration);
            setGstPercentage(parseFloat(resData?.gst) ?? 0);
            setHsnValue(resData?.hsn_code);
          }
        }
      })
      .catch((error) => {
        C2CConsole.error(error);
      });
  }

  const onSubmit = (data) => {
    let api_url = "";
    let edit_url = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      api_url = "/clinic/create-procedure";
      edit_url = "/clinic/edit-procedure";
      payload = {
        "authorizer-principal-id": {
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        // user_agent: "web",
        ...(userType == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),

        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
          doctorRole == USER_ROLE.RESOURCE_ADMIN ||
          userType == APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
        user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    } else {
      api_url = "/doctor/create-procedure";
      edit_url = "/doctor/edit-procedure";
      payload = {
        doctor_id:
          userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
        "authorizer-principal-id": {
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        // user_agent: "web",
        ...(userType == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    }

    if (consultationType.value == "4") {
      setLoader(true);
      afterLoginApiAxios({
        method: "post",
        url: api_url,
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          procedure_name:
            localStorage.getItem("isResourceArray") === "True" ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT
              ? data?.procedure_name?.label
              : data?.procedure_name,
          consultation_duration: data.slots.value,
          consultation_fees: data.fees,
          add_instructions: data.instruction.trim(),
          consultation_method:
            data.consultation_method === "online" ? "true" : "false",
          discount_percentage: data.discount,
          enable_online_payment: allowOnlinePayment,
          discounted_amount: discount_fees.toString(),
          doctor_commission_percentage: commission
            ? roundToTwoDecimalPlaces(commission)
            : "",
          resource_mapping_id: data?.procedure_name?.resourceIds,
          ...payload,
          gst: gstPercentage,
          hsn_code: hsnValue,
        },
      })
        .then((response) => {
          if (response.data) {
            setLoader(false);
            if (response.data.statusCode === 200) {
              setProcedureConsultationType({
                id: "4",
                value: response.data.procedure_id,
                label:
                  localStorage.getItem("isResourceArray") === "True" ||
                  doctorRole === USER_ROLE.RESOURCE_CONSULTANT
                    ? data?.procedure_name.label
                    : data.procedure_name,
              });
              if (doctor_context?.clinic_id) {
                callGetDoctorResourceAPI(doctor_context?.clinic_id);
              }
              setTimePicker(true);
            } else if (response.data.statusCode == 500) {
              setErrorModal(true);
            }
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    } else {
      setLoader(true);
      afterLoginApiAxios({
        method: "post",
        url: edit_url,
        headers: {
          authorization: localStorage.getItem("id_token"),
        },
        data: {
          ...payload,
          procedure_id: procedure_id,
          procedure_name:
            localStorage.getItem("isResourceArray") === "True" ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT
              ? procedure_name
              : data?.procedure_name,
          consultation_duration: data.slots.value,
          consultation_fees: data.fees,
          add_instructions: data.instruction.trim(),
          consultation_method:
            data.consultation_method === "online" ? "True" : "False",
          discount_percentage: data.discount,
          enable_online_payment: allowOnlinePayment,
          enable_procedure: toggleButton,
          discounted_amount: discount_fees.toString(),
          doctor_commission_percentage: commission
            ? roundToTwoDecimalPlaces(commission)
            : "",
          ...(localStorage.getItem("isResourceArray") === "True" ||
          doctorRole === USER_ROLE.RESOURCE_CONSULTANT
            ? { resource_mapping_id: resourceId }
            : {}),
          gst: gstPercentage,
          hsn_code: hsnValue,
        },
      })
        .then((response) => {
          if (response.data) {
            setLoader(false);
            if (response.data.statusCode === 200) {
              setSelectedConsultationType({
                id: "4",
                value: response.data.procedure_id,
              });
              setProcedureConsultationType({
                //newly added
                id: "4",
                value: response.data.procedure_id,
                label:
                  localStorage.getItem("isResourceArray") === "True" ||
                  doctorRole === USER_ROLE.RESOURCE_CONSULTANT
                    ? procedure_name
                    : data?.procedure_name,
              });
              if (doctor_context?.clinic_id) {
                callGetDoctorResourceAPI(doctor_context?.clinic_id);
              }
              if (peviousSlotValue.slotType != data.slots.slotType) {
                setTimePicker(true);
              } else {
                setUpdateModal(true);
              }
            } else {
              setEditErrorMessage(
                response.data.message ? response.data.message : ""
              );
              setEditError(true);
            }
          }
        })
        .catch((error) => {
          C2CConsole.error(error);
        });
    }
    if (selectedConsultationType.common_procedure) {
      setCommonProcedure(true);
    } else {
      setCommonProcedure(false);
    }
  };

  // Helper Methods

  const getFinalCost = (value) => {
    let costBeforeRoundup = (Number(value) / 94.4287) * 100;
    let lowerLimit =
      Number(Math.floor(costBeforeRoundup).toFixed(2)) + Number(0.01);
    const finalCost =
      costBeforeRoundup > lowerLimit
        ? parseFloat(costBeforeRoundup.toFixed(2))
        : Math.floor(lowerLimit);

    return finalCost;
  };

  // <===

  // function to handle fees
  const handleFees = (value) => {
    setFees(value);
    if (isNaN(value)) {
      setpayableFee(0);
    }
    const finalCost = getFinalCost(value);
    setpayableFee(finalCost);
    applyDiscount(discount, finalCost);
    removeDiscountData();
  };

  const preventNegativeInput = (event) => {
    const invalidKeys = ["-", "e", "+", "."];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  const handleFeesEdit = (fees) => {
    if (isNaN(fees)) {
      return "";
    }

    return getFinalCost(fees);
  };

  //function for instruction
  const handleInstruction = (e) => {
    setInstruction(e.target.value);
  };

  //function to set discount state
  const handleDiscount = (value) => {
    setDiscount(value);
    if (value === "" || value === 0) {
      setDiscountPercentage(0);
    }
    let discountData =
      discountPercentage === 0 || value === ""
        ? value
        : discountPercentage + Number(value);
    applyDiscount(discountData);
    removeDiscountData();
  };

  const calculateTotalAmount = () => {
    // Calculate total after discount
    const discountedAmount = fees - (fees * discount) / 100;

    // Calculate total after commission
    const totalAmount =
      discountedAmount - (discountedAmount * commission) / 100;

    // Calculate total commission
    let totalCommissionFee = discountedAmount - totalAmount;

    setTotalCommission(parseFloat(totalCommissionFee.toFixed(2)));
  };
  const handleCommission = (value) => {
    setCommission(value);
  };

  //function to apply discount
  const applyDiscount = (appliedDiscount, fee) => {
    if (appliedDiscount) {
      let newFee = (fee ?? payableFee) * (appliedDiscount / 100);
      let lowerLimit = Number(newFee).toFixed(2);
      const finalCost = newFee > lowerLimit ? newFee : lowerLimit;
      {
        (fee ?? payableFee) - finalCost > 0
          ? setdiscountedFees(
              parseFloat(((fee ?? payableFee) - finalCost).toFixed(2))
            )
          : setdiscountedFees(0);
      }
    } else {
      setdiscountedFees(0);
    }
  };

  //function to procedure name
  const handleProcedureName = (e) => {
    setProcedureName(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.target.value.length < 1 && e.charCode == 32) {
      e.preventDefault();
    }
  };
  //function to handle consultation method
  const handleConsultationMethod = (e) => {
    setConsultationMethod(e.target.value);
  };

  //function to AllowOnliePayment
  const handleAllowOnliePayment = () => {
    setAllowOnlinePayment(!allowOnlinePayment);
  };

  //function to disable and enable procedure.
  const handleChange = (event) => {
    settoggleButton(event.target.checked);
  };

  //function to delete the procedure.

  const deletProcedure = () => {
    let delete_url = "";
    let payload = {};
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      doctor_context?.clinic_id
    ) {
      delete_url = "/clinic/delete-procedure";
      payload = {
        doctor_id:
          doctorRole == USER_ROLE.DOCTOR_ADMIN ||
          doctorRole == USER_ROLE.RESOURCE_ADMIN ||
          userType == APPLICABLE_ROLE.STAFF
            ? staffDoctor.id
            : userId,
        clinic_id: doctor_context?.clinic_id,
        "authorizer-principal-id": {
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        ...(userType == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        procedure_id: procedure_id ? procedure_id : "",
        user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    } else {
      delete_url = "/doctor/delete-procedure";
      payload = {
        doctor_id:
          userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
        "authorizer-principal-id": {
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          user_id: userId,
          agent: "web",
        },
        ...(userType == APPLICABLE_ROLE.STAFF && {
          staff_id: staffId,
        }),
        user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
      };
    }
    setLoader(true);
    afterLoginApiAxios({
      method: "post",
      url: delete_url,
      headers: {
        authorization: localStorage.getItem("id_token"),
      },
      data: {
        procedure_id: procedure_id,
        ...payload,
        confirm_delete: isDeleted,
      },
    })
      .then((res) => {
        if (res.data.statusCode == 500) {
          setpendingappointments(res.data.appointment_count);
        }
        if (res.data.statusCode == 200) {
          (localStorage.getItem("isResourceArray") === "True" ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT) &&
            getProcedure(procedureConsultationType.value);

          getProcedure("");
          setSelectedConsultationType({
            value: "0",
            id: "0",
            label: "Tele-Consult Regular",
          });
        }
        if (doctor_context?.clinic_id) {
          callGetDoctorResourceAPI(doctor_context?.clinic_id);
        }
        setLoader(false);
      })
      .catch((er) => {
        C2CConsole.log("error", er);
      });
  };

  //function to show delete procedure popup
  const deleteConfirm = () => {
    deletProcedure();
    setIsDeleted(true);
    setdeletemodal(true);
  };

  const deletProcedureConform = () => {
    deletProcedure();
    setdeletemodal(false);
  };

  //function to select slot value
  const handleSelect = (value) => {
    setProcedureSlotValue(value);
  };

  const CaretDownIcon = () => {
    return <i class="fa fa-caret-down fa-2x" aria-hidden="true"></i>;
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <CaretDownIcon />
      </components.DropdownIndicator>
    );
  };

  const handleTitle = (data) => {
    setTitle(data);
  };

  const handleCheckbox = (e, id) => {
    let arr = checkboxValue;
    arr.map((data, index) => {
      if (data.checked === true) {
        if (data.id !== id) {
          data.checked = false;
        }
        setCheckboxValue([...arr]);
        setDiscountPercentage(0);
      } else if (data.id == id) {
        data.checked = e.target.checked;
        setCheckboxValue([...arr]);
        setDiscountPercentage(data.value);
        setDiscount(data.value + Number(discount));
        applyDiscount(data.value + Number(discount));
      }
    });
  };
  const removeDiscountData = () => {
    let arr = checkboxValue;
    arr.map((data, index) => {
      if (data.checked === true) {
        data.checked = false;
      }
      setCheckboxValue([...arr]);
    });
  };
  return (
    // TODO: add edit in-clinic settings form
    <>
      {loading ? <Loader /> : null}
      <form onSubmit={handleSubmit(onSubmit)}>
        <section className="form-wrapper">
          <div className="row">
            {consultationType.value != "4" && (
              <>
                <FormGroup
                  className="procedure-icons"
                  style={{
                    marginBottom:
                      localStorage.getItem("isResourceArray") === "True"
                        ? "-50px"
                        : "-30px",
                    zIndex: 1,
                  }}
                >
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        checked={toggleButton}
                        onChange={handleChange}
                        name="checkedB"
                      />
                    }
                  />
                  <div className="delete_section">
                    <img src={deleteIcon} onClick={deleteConfirm} />
                  </div>
                </FormGroup>
                {!toggleButton ? (
                  <div className="msg_disable">
                    {procedure_name} has been disabled. Enable the procedure for
                    patients to book appointments
                  </div>
                ) : (
                  ""
                )}
              </>
            )}
            {localStorage.getItem("isResourceArray") === "True" ||
            doctorRole === USER_ROLE.RESOURCE_CONSULTANT ? (
              !procedure_id && (
                <div className="col-lg-12 col-12 form-wrapper-input mt-3">
                  <label className="required">Procedure Name</label>
                  <Controller
                    control={control}
                    defaultValue={null}
                    rules={{ required: true }}
                    name={"procedure_name"}
                    render={({ onChange, value, name }) => (
                      <Select
                        className="select-field"
                        onChange={(selectedValue) => {
                          onChange(selectedValue);
                        }}
                        options={resourceData}
                        placeholder=""
                        value={value}
                        name={name}
                        components={{ DropdownIndicator }}
                      />
                    )}
                  />
                </div>
              )
            ) : (
              <div className="col-lg-12 col-12 form-wrapper-input">
                <label className="required">Procedure Name</label>
                <input
                  name="procedure_name"
                  autoComplete="off"
                  ref={register({ required: true })}
                  maxLength="160"
                  onChange={handleProcedureName}
                  onKeyPress={handleKeyPress}
                />{" "}
                <p
                  className={
                    160 - procedure_name.length == 0
                      ? "text-red"
                      : 160 - procedure_name.length > 0 &&
                        160 - procedure_name.length < 160
                      ? "text-green"
                      : ""
                  }
                >
                  Characters left : {160 - procedure_name.length} of 160
                </p>
                {errors.procedure_name ? (
                  <p className="error">Please enter the procedure name.</p>
                ) : (
                  ""
                )}
              </div>
            )}
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label className="required">
                {localStorage.getItem("isResourceArray") === "True" ||
                doctorRole === USER_ROLE.RESOURCE_CONSULTANT
                  ? "Procedure Duration"
                  : "Consultation Duration"}
              </label>
              <Controller
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                name={"slots"}
                render={({ onChange, value, name }) => (
                  <Select
                    className="select-field"
                    onChange={(selectedValue) => {
                      onChange(selectedValue);
                      handleSelect(selectedValue);
                    }}
                    options={PROCEDURE_SLOTS}
                    placeholder=""
                    value={value}
                    name={name}
                    components={{ DropdownIndicator }}
                  />
                )}
              />
              {errors.slots ? (
                <p className="error">Please enter the duration.</p>
              ) : (
                ""
              )}
            </div>
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label className="required" for="fees">
                Consultation Fees
              </label>
              <div class="input-group-prepend fee-input">
                <span class="input-group-text rs_style">₹</span>
                <input
                  type="number"
                  name="fees"
                  min={0}
                  autoComplete="off"
                  className="inputStyle"
                  ref={register({ required: true })}
                  onChange={(e) => handleFees(e.target.value)}
                  onKeyDown={(e) => preventNegativeInput(e)}
                />{" "}
                {/**, pattern: onlyDigitRegex */}
              </div>
              <p>Fees seen by Patient : ₹ {handleFeesEdit(fees)}</p>
              {errors.fees ? <p className="error">Please enter fees.</p> : ""}
            </div>
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label for="instruction">Add Instructions (optional)</label>
              <textarea
                className="input-scrollStyle"
                name="instruction"
                autoComplete="off"
                ref={register}
                maxLength="500"
                onChange={handleInstruction}
              />{" "}
              {/**, pattern: onlyDigitRegex */}
              <p
                className={
                  500 - instruction.length == 0
                    ? "text-red"
                    : 500 - instruction.length > 0 &&
                      500 - instruction.length < 500
                    ? "text-green"
                    : ""
                }
              >
                Characters left : {500 - instruction.length} of 500
              </p>
            </div>
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label className="required" for="consultation_method">
                Consultation Method
              </label>
              <div className="consultation-option">
                {" "}
                {/**options-list */}
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input mt-0"
                    type="radio"
                    value="offline"
                    id="offline"
                    checked={consultation_method == "offline" ? true : false}
                    name="consultation_method"
                    ref={register({ required: true })}
                    onChange={handleConsultationMethod}
                  />
                  <label for="offline" className="mb-0 ml-2">
                    <span>Offline Only</span>
                  </label>
                </div>
              </div>
              {errors.consultation_method ? (
                <p className="pl-1 pt-1 error">
                  Please enter consultation method.
                </p>
              ) : (
                ""
              )}
            </div>
            {consultation_method === "offline" ? (
              <div className="col-lg-12 col-12 form-wrapper-input mt-3">
                <label class="container-checkbox">
                  Enable Online Payment
                  <input
                    type="checkbox"
                    name="enable_online"
                    checked={allowOnlinePayment}
                    ref={register}
                    onChange={handleAllowOnliePayment}
                  />
                  <span class="checkmark"></span>
                </label>
                <p className="checkbox-p">6% service charge will be applied</p>
              </div>
            ) : null}
            <div className="col-lg-12 col-12 form-wrapper-input mt-3">
              <label for="discount">Discount (optional)</label>
              <div class="input-group-prepend fee-input">
                <span class="input-group-text rs_style">Discount %</span>
                <input
                  type="number"
                  name="discount"
                  value={discount}
                  min={0}
                  max={100}
                  step="any"
                  autoComplete="off"
                  className="dis_inputStyle"
                  ref={register}
                  disabled={hasAppliedDiscount}
                  onChange={(e) => handleDiscount(e.target.value)}
                  onKeyDown={(e) => preventNegativeInput(e)}
                />{" "}
                {/**, pattern: onlyDigitRegex */}
              </div>
              <div className="mt-3" style={{ alignSelf: "flex-end" }}>
                <div
                  class="button-group-pills text-center"
                  data-toggle="buttons"
                >
                  {checkboxValue.map((data, index) => (
                    <label
                      class={`btn btn-default ${
                        data.checked ? "active" : ""
                      } ml-2`}
                      id={index}
                      style={{
                        fontWeight: "bold",
                        borderRadius: "12px",
                        width: "50px",
                        borderColor: "#56CDE8",
                        backgroundColor: data.checked ? "#56CDE8" : "#fff",
                      }}
                    >
                      {" "}
                      {/**active */}
                      <input
                        id={index}
                        type="checkbox"
                        name="options"
                        checked={data.checked}
                        onClick={(e) => handleCheckbox(e, data.id)}
                      />
                      <div style={{ color: data.checked ? "#fff" : "#56CDE8" }}>
                        {data.name}
                      </div>
                    </label>
                  ))}
                </div>
              </div>
              <p>Discounted Fees seen by Patient : ₹ {discount_fees}</p>
            </div>
            <GSTDropdown
              gstValue={gstPercentage}
              hsnValue={hsnValue}
              hsnError={hsnError}
              hsnMandatory={hsnMandatory}
              amountWithoutGST={calculateDiscountedAmount(fees, discount)}
              setHsnValue={setHsnValue}
              handleGST={(value) => {
                setGstPercentage(value);
              }}
            />
            {(doctorRole === USER_ROLE.DOCTOR_ADMIN ||
              doctorRole === USER_ROLE.RESOURCE_ADMIN ||
              doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
              doctorRole === USER_ROLE.RESOURCE_CONSULTANT) && (
              <div className="col-lg-12 col-12 form-wrapper-input mt-3">
                <label for="discount">Doctor Commission (Optional)</label>
                <div class="input-group-prepend fee-input">
                  <span class="input-group-text rs_style">Commission % </span>
                  <input
                    type="number"
                    name="commission"
                    value={commission}
                    min={0}
                    max={100}
                    step="any"
                    autoComplete="off"
                    className="dis_inputStyle"
                    ref={register}
                    disabled={
                      doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
                      doctorRole === USER_ROLE.RESOURCE_CONSULTANT
                    }
                    onChange={(e) => handleCommission(e.target.value)}
                  />{" "}
                </div>
                <p>Commission Payout to the Doctor is : ₹ {totalCommission}</p>
              </div>
            )}
          </div>
          <div className="mt-4 text-center">
            <button
              className="btn primary-cta-button rounded-pill py-2 px-2"
              disabled={CTAEnable || hsnError}
            >
              Save
            </button>
          </div>
        </section>
      </form>

      <MyScheduleModal
        show={deletemodal}
        name="deleteProcedureModal"
        okayClickHandler={() => setdeletemodal(false)}
        pendingappointments={pendingappointments}
        procedureName={procedure_name}
        deleteprocedure={deletProcedureConform}
      />
      <MyScheduleModal
        show={createModal}
        name="addProcedureModal"
        okayClickHandler={() => {
          setcreateModal(false);
        }}
        procedureName={consultationType.label}
      />
      <MyScheduleModal
        show={ErrorModal}
        okayClickHandler={() => {
          setErrorModal(false);
        }}
        name="ErrorModal"
        title="Procedure name already exists"
        subtitle="A procedure with the same name already exists. Please specify another name."
      />
      <MyScheduleModal
        show={offlineCheck}
        okayClickHandler={() => setofflineCheck(false)}
        name="offlineCheck"
        title="Cannot Create  this Type of Procedure!"
        subtitle="Try some other method."
      />
      <MyScheduleModal
        show={updateModal}
        okayClickHandler={() => {
          setUpdateModal(false);
          getProcedure(procedureConsultationType.value);
        }}
        name="procedureModal"
      />
      <MyScheduleModal
        show={slotSuccessModal}
        procedureName={procedureConsultationType.label}
        okayClickHandler={() => {
          setSlotSuccessModal(false);
          getProcedure(procedureConsultationType.value);
        }}
        name="timeRangeModal"
        title={title}
      />
      <TimePickerModal
        open={showtimepicker}
        handleCloseTimeModal={() => {
          setTimePicker(false);
          getProcedure(procedureConsultationType.value);
        }}
        typeOfSlot={"add"}
        consultationType={procedureConsultationType}
        slotValue={procedure_slotValue}
        handleSaveTimerModal={() => {
          setTimePicker(false);
          handleProcedureCounter();
          setSlotSuccessModal(true);
        }}
        handleTitle={handleTitle}
        staffDoctor={staffDoctor}
      />

      <MyScheduleModal
        show={editerror}
        okayClickHandler={() => {
          setEditError(false);
          getParticularProcedure();
        }}
        name="ErrorModal"
        title="Error"
        subtitle={editerror_message}
      />
    </>
  );
}
